var hexcase = 0;
function hex_md5(A) {
  return rstr2hex(rstr_md5(str2rstr_utf8(A)));
}
function hex_hmac_md5(B, A) {
  return rstr2hex(rstr_hmac_md5(str2rstr_utf8(B), str2rstr_utf8(A)));
}
function rstr_md5(A) {
  return binl2rstr(binl_md5(rstr2binl(A), A.length * 8));
}
function rstr_hmac_md5(E, G) {
  var C = rstr2binl(E);
  if (C.length > 16) {
    C = binl_md5(C, E.length * 8);
  }
  var F = Array(16),
    B = Array(16);
  for (var D = 0; D < 16; D++) {
    F[D] = C[D] ^ 909522486;
    B[D] = C[D] ^ 1549556828;
  }
  var A = binl_md5(F.concat(rstr2binl(G)), 512 + G.length * 8);
  return binl2rstr(binl_md5(B.concat(A), 512 + 128));
}
function rstr2hex(D) {
  try {
    hexcase;
  } catch (A) {
    hexcase = 0;
  }
  var F = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var C = "";
  var E;
  for (var B = 0; B < D.length; B++) {
    E = D.charCodeAt(B);
    C += F.charAt((E >>> 4) & 15) + F.charAt(E & 15);
  }
  return C;
}
function str2rstr_utf8(D) {
  var C = "";
  var A = -1;
  var E, B;
  while (++A < D.length) {
    E = D.charCodeAt(A);
    B = A + 1 < D.length ? D.charCodeAt(A + 1) : 0;
    if (55296 <= E && E <= 56319 && 56320 <= B && B <= 57343) {
      E = 65536 + ((E & 1023) << 10) + (B & 1023);
      A++;
    }
    if (E <= 127) {
      C += String.fromCharCode(E);
    } else {
      if (E <= 2047) {
        C += String.fromCharCode(192 | ((E >>> 6) & 31), 128 | (E & 63));
      } else {
        if (E <= 65535) {
          C += String.fromCharCode(
            224 | ((E >>> 12) & 15),
            128 | ((E >>> 6) & 63),
            128 | (E & 63)
          );
        } else {
          if (E <= 2097151) {
            C += String.fromCharCode(
              240 | ((E >>> 18) & 7),
              128 | ((E >>> 12) & 63),
              128 | ((E >>> 6) & 63),
              128 | (E & 63)
            );
          }
        }
      }
    }
  }
  return C;
}
function rstr2binl(A) {
  var C = Array(A.length >> 2);
  for (var B = 0; B < C.length; B++) {
    C[B] = 0;
  }
  for (B = 0; B < A.length * 8; B += 8) {
    C[B >> 5] |= (A.charCodeAt(B / 8) & 255) << B % 32;
  }
  return C;
}
function binl2rstr(A) {
  var C = "";
  for (var B = 0; B < A.length * 32; B += 8) {
    C += String.fromCharCode((A[B >> 5] >>> B % 32) & 255);
  }
  return C;
}
function binl_md5(B, D) {
  B[D >> 5] |= 128 << D % 32;
  B[(((D + 64) >>> 9) << 4) + 14] = D;
  var G = 1732584193;
  var F = -271733879;
  var I = -1732584194;
  var H = 271733878;
  for (var K = 0; K < B.length; K += 16) {
    var C = G;
    var E = F;
    var J = I;
    var A = H;
    G = md5_ff(G, F, I, H, B[K + 0], 7, -680876936);
    H = md5_ff(H, G, F, I, B[K + 1], 12, -389564586);
    I = md5_ff(I, H, G, F, B[K + 2], 17, 606105819);
    F = md5_ff(F, I, H, G, B[K + 3], 22, -1044525330);
    G = md5_ff(G, F, I, H, B[K + 4], 7, -176418897);
    H = md5_ff(H, G, F, I, B[K + 5], 12, 1200080426);
    I = md5_ff(I, H, G, F, B[K + 6], 17, -1473231341);
    F = md5_ff(F, I, H, G, B[K + 7], 22, -45705983);
    G = md5_ff(G, F, I, H, B[K + 8], 7, 1770035416);
    H = md5_ff(H, G, F, I, B[K + 9], 12, -1958414417);
    I = md5_ff(I, H, G, F, B[K + 10], 17, -42063);
    F = md5_ff(F, I, H, G, B[K + 11], 22, -1990404162);
    G = md5_ff(G, F, I, H, B[K + 12], 7, 1804603682);
    H = md5_ff(H, G, F, I, B[K + 13], 12, -40341101);
    I = md5_ff(I, H, G, F, B[K + 14], 17, -1502002290);
    F = md5_ff(F, I, H, G, B[K + 15], 22, 1236535329);
    G = md5_gg(G, F, I, H, B[K + 1], 5, -165796510);
    H = md5_gg(H, G, F, I, B[K + 6], 9, -1069501632);
    I = md5_gg(I, H, G, F, B[K + 11], 14, 643717713);
    F = md5_gg(F, I, H, G, B[K + 0], 20, -373897302);
    G = md5_gg(G, F, I, H, B[K + 5], 5, -701558691);
    H = md5_gg(H, G, F, I, B[K + 10], 9, 38016083);
    I = md5_gg(I, H, G, F, B[K + 15], 14, -660478335);
    F = md5_gg(F, I, H, G, B[K + 4], 20, -405537848);
    G = md5_gg(G, F, I, H, B[K + 9], 5, 568446438);
    H = md5_gg(H, G, F, I, B[K + 14], 9, -1019803690);
    I = md5_gg(I, H, G, F, B[K + 3], 14, -187363961);
    F = md5_gg(F, I, H, G, B[K + 8], 20, 1163531501);
    G = md5_gg(G, F, I, H, B[K + 13], 5, -1444681467);
    H = md5_gg(H, G, F, I, B[K + 2], 9, -51403784);
    I = md5_gg(I, H, G, F, B[K + 7], 14, 1735328473);
    F = md5_gg(F, I, H, G, B[K + 12], 20, -1926607734);
    G = md5_hh(G, F, I, H, B[K + 5], 4, -378558);
    H = md5_hh(H, G, F, I, B[K + 8], 11, -2022574463);
    I = md5_hh(I, H, G, F, B[K + 11], 16, 1839030562);
    F = md5_hh(F, I, H, G, B[K + 14], 23, -35309556);
    G = md5_hh(G, F, I, H, B[K + 1], 4, -1530992060);
    H = md5_hh(H, G, F, I, B[K + 4], 11, 1272893353);
    I = md5_hh(I, H, G, F, B[K + 7], 16, -155497632);
    F = md5_hh(F, I, H, G, B[K + 10], 23, -1094730640);
    G = md5_hh(G, F, I, H, B[K + 13], 4, 681279174);
    H = md5_hh(H, G, F, I, B[K + 0], 11, -358537222);
    I = md5_hh(I, H, G, F, B[K + 3], 16, -722521979);
    F = md5_hh(F, I, H, G, B[K + 6], 23, 76029189);
    G = md5_hh(G, F, I, H, B[K + 9], 4, -640364487);
    H = md5_hh(H, G, F, I, B[K + 12], 11, -421815835);
    I = md5_hh(I, H, G, F, B[K + 15], 16, 530742520);
    F = md5_hh(F, I, H, G, B[K + 2], 23, -995338651);
    G = md5_ii(G, F, I, H, B[K + 0], 6, -198630844);
    H = md5_ii(H, G, F, I, B[K + 7], 10, 1126891415);
    I = md5_ii(I, H, G, F, B[K + 14], 15, -1416354905);
    F = md5_ii(F, I, H, G, B[K + 5], 21, -57434055);
    G = md5_ii(G, F, I, H, B[K + 12], 6, 1700485571);
    H = md5_ii(H, G, F, I, B[K + 3], 10, -1894986606);
    I = md5_ii(I, H, G, F, B[K + 10], 15, -1051523);
    F = md5_ii(F, I, H, G, B[K + 1], 21, -2054922799);
    G = md5_ii(G, F, I, H, B[K + 8], 6, 1873313359);
    H = md5_ii(H, G, F, I, B[K + 15], 10, -30611744);
    I = md5_ii(I, H, G, F, B[K + 6], 15, -1560198380);
    F = md5_ii(F, I, H, G, B[K + 13], 21, 1309151649);
    G = md5_ii(G, F, I, H, B[K + 4], 6, -145523070);
    H = md5_ii(H, G, F, I, B[K + 11], 10, -1120210379);
    I = md5_ii(I, H, G, F, B[K + 2], 15, 718787259);
    F = md5_ii(F, I, H, G, B[K + 9], 21, -343485551);
    G = safe_add(G, C);
    F = safe_add(F, E);
    I = safe_add(I, J);
    H = safe_add(H, A);
  }
  return Array(G, F, I, H);
}
function md5_cmn(A, C, B, E, D, F) {
  return safe_add(bit_rol(safe_add(safe_add(C, A), safe_add(E, F)), D), B);
}
function md5_ff(A, G, B, F, C, D, E) {
  return md5_cmn((G & B) | (~G & F), A, G, C, D, E);
}
function md5_gg(A, G, B, F, C, D, E) {
  return md5_cmn((G & F) | (B & ~F), A, G, C, D, E);
}
function md5_hh(A, G, B, F, C, D, E) {
  return md5_cmn(G ^ B ^ F, A, G, C, D, E);
}
function md5_ii(A, G, B, F, C, D, E) {
  return md5_cmn(B ^ (G | ~F), A, G, C, D, E);
}
function safe_add(D, A) {
  var C = (D & 65535) + (A & 65535);
  var B = (D >> 16) + (A >> 16) + (C >> 16);
  return (B << 16) | (C & 65535);
}
function bit_rol(B, A) {
  return (B << A) | (B >>> (32 - A));
}

export { hex_md5 as md5, hex_hmac_md5 };
